import { BaseService } from "./BaseService";
import { Organization, OrganizationData } from "../models/Organization";

interface OrgDepartment {
    departmentId: number;
    departmentName: string;
}

class OrganizationServiceClass extends BaseService {
    protected get baseUrl(): string {
        return `${process.env.NEXT_PUBLIC_API_URL}/api/organization/`;
    }

    async getOrganizations(): Promise<Organization[]> {
        return this.get("GetOrganizationList");
    }

    async getDepartmentsByOrganizationId(
        orgId: number
    ): Promise<OrgDepartment[]> {
        return this.get<OrgDepartment[]>(
            `GetDepartmentListForOrganization/${orgId}`
        );
    }

    async createOrganization(data: OrganizationData): Promise<Organization> {
        return this.post("CreateOrganization", data);
    }

    async updateOrganization(
        id: number,
        data: OrganizationData
    ): Promise<Organization> {
        return this.put(`UpdateOrganization`, { ...data, orgId: id });
    }

    async deleteOrganization(id: number): Promise<void> {
        await this.delete(`DeleteOrganization/${id}`);
    }
}

export const organizationService = new OrganizationServiceClass();
